import script from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=7c8cf13e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8cf13e"]])

export default __exports__